// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum SessionActionType {
    Restore = 1,
    Explore = 2
}
